import { asyncThunkCreator, buildCreateSlice } from '@reduxjs/toolkit';
import { initialState } from './initial';
import { reducers } from './reducers';

export const createAppSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});

export const passcodeListsSlice = createAppSlice({
  name: 'passcodeLists',
  initialState,
  reducers,
});

export const {
  fetchPasscodeList,
  fetchPasscodeLists,
  fetchPasscodeListMembers,
  resetPasscodeListAndMembers,
  fetchPasscodeListMemberCount,
  fetchPasscodeListAssociatedEvents,
  fetchPasscodeListAssociatedEventsDetails,
  fetchMemberPasscodeLists,
  fetchMagicLinkRegistrationsPasscodeList,
} = passcodeListsSlice.actions;

export default passcodeListsSlice.reducer;
